export const tableHeader = (t) => [
    {
        id: 'name',
        type: 'text',
        value: t('company:companies.table.name'),
    },
    {
        id: 'description',
        type: 'text',
        value: t('company:companies.table.description'),
        maxSize: 48
    },
    {
        id: 'cnpj',
        type: 'string',
        value: 'CNPJ',
    },
    {
        id: 'active',
        type: 'boolean',
        value: t('company:companies.table.active'),
    },
    {
        id: 'partner',
        type: 'boolean',
        value: t('company:companies.table.partner'),
    },
    {
        id: 'action',
        type: 'actions-redirect',
        value: '',
    },
]
